export class cCheckout {
  div_container   = document.querySelector('.woocommerce-account-fields:has(#createaccount)') as HTMLElement|null;
  h2_accountTitle = document.createElement('h2');

  constructor() {
    const { __ } = wp.i18n as i18n;

    document.body.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('a.c-reserve-info-link') === null) return;
      event.preventDefault();

      document.querySelector('.c-reserve-info')?.classList.toggle('c-open');
    });

    if (this.div_container === null) return;

    this.div_container.prepend(this.h2_accountTitle);
    this.h2_accountTitle.textContent = __('Konto eröffnen', 'custom');
  }
}